// extracted by mini-css-extract-plugin
module.exports = {"writtenReviews":"WrittenReviews_writtenReviews__pXpMS","hidden":"WrittenReviews_hidden__Uazdo","useV53Styling":"WrittenReviews_useV53Styling___ekun"};